import React, { useEffect, useState } from "react";
import Loader from "../CustomComponents/Loader";
import HomeLayout from "../Layout/HomeLayout";
import KudzuPluseLogo from "../../assets/kudzu-plus-images/KudzuPluseLogo.png";
import Footer from "../Layout/Footer";
import Benificiary from "../../../src/assets/kudzu-plus-images/Benificiary.png";
import NotificationModal from "../CustomComponents/NotificationModal";
import SmiPayPerks from "../CustomComponents/SmiPayPerks";
import { useDispatch, useSelector, connect } from "react-redux";
import KudzuPlusLogo from '../../../src/assets/kudzu-plus-images/K-plus-logo.png'
import {
  CHECKING_CARD_CODE,
  SAVING,
  SECURED_CARD_CODE,
  SMIONE_CARD_CODE,
  appTheme,
  getUserMembership,
  retrieveData,
  showKudzuPlusPrompt,
  subScriptionCanceledFun,
} from "../../helpers/utils/Utils";
import {
  STATUS_SUCCESS_CODE,
  GET_USED_AMOUNT_DETAILS,
  TRANSACTIONS,
  SAVINGS,
  CHECKING,
  SPENDING,
  isDEV,
  ISDEV_ENV,
  SAVING_CARD_CODE,
  GENERATE_OTP_VIEW_CARD,
  GENERATE_UNLOCK_CARD_OTP,
  LOCK_CARD_API,
  UNLOCK_CARD_API,
  CAN_CREATE_SAVINGS_ACC,
  PAID_PROMO_KEY,
} from "../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../network/NetworkUtils";
import { fetchConfigarationData } from "../../helpers/utils/Utils";
import HomeHeader from "../CustomComponents/HomeHeader";
import Checking from "./Checking";
import Savings from "./Savings";
import PayPerks from "../CustomComponents/PayPerks";
import {
  withOidcSecure,
  useOidcUser,
  useOidcAccessToken,
  useOidc,
} from "@axa-fr/react-oidc";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  addLineBreaks,
  clearStorageExceptKey,
  convertTimestamp,
  storeData,
} from "../../utils";
import { store } from "../../Redux/store";
import { useNavigate } from "react-router-dom";
import CustomAlertModel from "../CustomComponents/CustomAlertModel";
import Modal from "../CustomComponents/Modal";
import Custom2FA from "../CustomComponents/Custom2FA";
import lockCardGreenTick from "../../assets/images/lock_green_tick.png";
import lockCardGreen from "../../assets/images/lock_green.png";
import unLockCardGreen from "../../assets/images/unlock_green.png";
import warningImg from "../../assets/images/warning.png";
import { LOGIN_SESSION_KEY, HIDE_SECURED_CREDIT_POPOVER } from "../../Redux/reducers";
import FooterContent from "../CustomComponents/Footer";
import AddMoneyComponent from "../CustomComponents/AddMoneyComponent";
import kudzuPlusLogo from "../../assets/kudzu-plus-images/kudzu-plus-white-logo.png";
import beneficiarysaving from "../../assets/images/beneficiarysaving.png";
import LineBreaks from "../../utils";
import TwoFactTypeSelctionModal from "../CustomComponents/TwoFactTypeSelctionModal";
import moment from "moment";
import logFirebaseEvents from "../LogFirebaseEvents";
import CustomModalPlus from "../../kudzu_plus/helpers/customModalPlus";
import CustomCarousel from "../../kudzu_plus/helpers/customCarousel";
// import DepositIcon from "../../assets/kudzu-plus-images/illo-direct-deposit.png"
import DepositIcon from "../../assets/kudzu-plus-images/post-down-arrow.png";
import Cookies from "js-cookie";
import MemnershipEnrollmentScreens from "../../kudzu_plus/components/membershipEnrollmentScreens";
import DynamicCard from "../CustomComponents/DynamicCard";
import CardHeading from "../CustomComponents/CardHeading";
import { width } from "../CustomComponents/DynamicCard/DynamicCardStyles";
import ach_acces_image  from '../../assets/kudzu-plus-images/post-down-arrow.png'
import crossIcon from '../../assets/kudzu-plus-images/crossIcon.png'
import { GET_NOTIFICATIONS} from "../../network/URLConstants";
import SmioneCard from "./SmioneCard";
import MembershipBanner from "../Banner/Banner";
import AddMoneyPopover from "./AddMoneyPopover";
import NewPayPerks from "./NewPayPerks";
import SecuredCreditPromoPopover from "../SecuredCredit/SecuredCreditPromoPopover"; 
import SecuredCreditCardPromotion from "./SecuredCreditCardPromotion";
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

const Home = ({ children }) => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);

  const { t } = useTranslation();
  const oidcUser = useOidcUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [checkingSpentAmmount, setCheckingSpentAmmount] = useState("");
  const [savingsSpentAmmount, setSavingsSpentAmmount] = useState("");
  const [userName, setUserName] = useState("");
  const [spendAmountDays, setSpendAmountDays] = useState(7);
  const [showWelcomHeader, setShowWelcomeHeader] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(true);
  const smiOneTrue = useSelector((state) => state.smiOneAccountTrue);
  const [isSMICard, setIsSMICard] = useState(false);
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const savingsCardAvailable = useSelector(
    (state) => state.savingsAccontAvailable
  );
  const cards = useSelector((state) => JSON.parse(state.userCards));

  
  const securedCard = cards?.find(card => card.AccountTypeBit63 === SECURED_CARD_CODE);
  const isSecuredCreditAccountAvailable = securedCard && securedCard.AccountTypeBit63 === SECURED_CARD_CODE ? true : false;
  const allowSecuredCredit = cards?.[0]?.AllowSecuredCredit ?? false;

  // API-driven secured credit popover state
  const showSecuredCreditPopover = useSelector((state) => state.showSecuredCreditPopover);
  
  const loggedResponse = useSelector((state) =>
    JSON.parse(state.loggedInResponse)
  );
  const userProfile = useSelector((state) => JSON.parse(state.userProfile));
  const userPreferredName = useSelector((state) => state.preferredName);
  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
  const subScriptionCanceled = subScriptionCanceledFun(loggedResponse);
  const kudzuPlusResponse = useSelector((state) => state.kudzuPlusResponse);
  
  //test comment
  const [promoKey, setPromoKey] = useState(
    loggedResponse?.Promos?.[0]?.PromoKey
  );
  const { logout } = useOidc();
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  var isUserLoggedIn = isLoggedIn;
  const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);

  const isEvenLength = cards !== null && cards.length % 2 === 0;
  const [selectedOption, setSelectedOption] = useState("");

  const [showModel, setShowModel] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const userMembershipData = getUserMembership(loggedResponse);


  const closedAddMoneyModalState = useSelector(state => state.closeAddMoneyPopover)

  // Add Money popover 
  const [addMoneyPopOver, setMoneyPopOver] = useState(false);
   const closeAddMoneyPopOver = () => {
    dispatch({
      type: "ADD_MONEY_MODAL_CLOSE",
      payload: { closeAddMoneyPopover: true }
    });
    setMoneyPopOver(false);
  };


  const redirectToAddMoney = () => {
    navigate("/AccountServices/Spending/TransferMoney")
    dispatch({
      type: "ADD_MONEY_MODAL_CLOSE",
      payload: { closeAddMoneyPopover: true }
    });
  };
  const HeadingStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[#ffffff]";
  const SubHeadingStyles =
    "font-serif-pro modal-title lg:text-[33px] md:text-[33px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] font-normal text-[var(--modal-edit-spendsense)] md:w-[80%]";

  const HighlightMsgStyles =
    "sm:w-auto w-[253px] font-serif-pro text-[var(--modal-text-highlight)] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal  cursor-pointer pointer-events-none";
  const HeaderMsgStyles =
    "font-serif-pro text-[var(--modal-text-heading-clr)]  modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus =
    "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";

  const SubHeaderMsgStyles =
    "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const summaryParagraphStyles =
    `font-hanken-grotesk modal-title ${promoKey == PAID_PROMO_KEY?'text-[#94C3E8]':'text-[white]'} lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none`;
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [modelImage, setModelImage] = useState("");
  const [carousel, setCarousel] = useState("");
  const [summaryParagraph, setSummaryParagraph] = useState("");
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [footerMsg, setFooterMsg] = useState("");
  const [btn1Focus, setBtn1Focus] = useState(false);
  const [btn2Focus, setBtn2Focus] = useState(false);
  const [modalBg, setModalBg] = useState("");
  const [btn1TextColor, setBtn1TextColor] = useState("");
  const [btn1BrExist, setBtn1BrExist] = useState(false);
  const [btn2TextColor, setBtn2TextColor] = useState("");
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [btn1BorderColor, setBtn1BorderColor] = useState("");
  const [quickActions, setQuickActions] = useState(true);
  const SelectedCardDetails = useSelector((state) => state.selectedCardDetails);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState("");

  const [showErrorImg, setshowErrorImg] = useState(false);
  const [cardDetails, setCardDetails] = useState({});
  const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
  const twoFactAuthenticationDone = useSelector(
    (state) => state.twoFactAuthenticationDone
  );
  const [show2faSelection, setshow2faSelection] = useState(false);
  const [otpGenerationType, setOtpGenerationType] = useState(false);
  const [savingsTheme, setSavingsTheme] = useState(false);
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  // const savingsCardExist = cards?.some(item => item.AccountTypeName === "Savings")
  const savingsWithBalanceOver0 = cards?.find((obj) => obj?.Balance > 0);
  const savingsCardExist = cards?.find((obj) => obj?.AccountTypeBit63 == 32);
  const [isSubFooter, setIsSubFooter] = useState(false);
  const [expiredFlow, setExpiredFlow] = useState('');
  const currentpath = useLocation();
  const hasKudzuCard = useSelector((state) => state.hasKudzuCard);
  let footerContentCount = 0;

  const [showSetupAccessCard, setShowSetupAccessCard] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [alerts, setAlerts] = useState(null);
  const [isShowNotificationContent, setIsShowNotificationContent] = useState(false);
  const accessToken = useSelector(state => state.accessToken);
  const [unreadCounts, setUnreadCounts] = useState(0);
  const rowsCountPerPage = useSelector(state => JSON.parse(state.notificationCountPerPage));
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const MFAValues = useSelector(state => state.b2cEnabled);
  


  const hnaldeSetupAccessCloseBtn = () => {
    setShowSetupAccessCard(false)
  }

  const fetchNotifications = async (isRead, isUnread) => {
    logFirebaseEvents("Notification", "View_More_Notification_Clicked", "View_More_Notification_Clicked", "", "");
    if (cards == null || cards == undefined) {
        return
    }
    try {
        setIsLoading(true);

        const deviceId = await retrieveData('updatedDeviceId')
      const cardKey = cards !== null
        ? cards?.find(item =>
          item.ProgramKey === (hasKudzuCard ? 200 : 112) &&
          item.AccountTypeBit63 === (hasKudzuCard ? 64 : 1)
        )?.CardKey
        : 0;
        const rowsPerPage = 25;
        const page = 1;

        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_NOTIFICATIONS(cardKey, isRead = false, isUnread = true, rowsPerPage, page, true)
        const response = await GetRequest(url, headers);
        const responseJson = await JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            setIsLoading(false);
            setAlerts(responseJson.Response.Alerts);
            console.log(responseJson.Response.Alerts.Items);
            const filteredNotification = responseJson.Response.Alerts.Items.filter(val => val.AlertTypeCode === "WRN");
            setNotifications(filteredNotification);
            setUnreadCounts(filteredNotification.length);
            if (filteredNotification.length > 0) {
              setIsShowNotificationContent(true);
              dispatch({
                type: "ANY_IN_APP_NOTIFICATIONS",
                payload: { anyInAppNotifications: true }
              });
            }
        
        }

    } catch (error) {
      setIsShowNotificationContent(false);
    }
}

useEffect(() => {
        fetchNotifications(false, true);
      }, [rowsCountPerPage])

  const checkNewAccountBasedOnApplicationDate = () => {
    const spendingCardAppDate = cards[0]?.ApplicationDate;
    // const spendingCardAppDate="2023-12-08T00:00:00";
    if (convertTimestamp(spendingCardAppDate, true) === "lessThan7days")
      setShowWelcomeHeader(true);
    else setShowWelcomeHeader(false);
  };

    useDocumentTitle(t('page_title_home'));

  useEffect(() => {
    logFirebaseEvents(
      "Home",
      "Home_Screen_visited",
      "Home_Screen_visited",
      "",
      ""
    );
    checkNewAccountBasedOnApplicationDate();
  }, []);

  useEffect(() => {
    //  alert(JSON.stringify(ShowPromptsTrue.ShowUpgradePrompts))
    // console.log(ShowPromptsTrue.ShowUpgradePrompts,"show prompt value")
    //  console.log(kudzuPlusResponse.ShowUpgradePrompts,"show prompt value")
  }, []);

  // const handleLogout = () => {

  //   if (isUserLoggedIn) {
  //     alert('1')
  //     isUserLoggedIn = false
  //     logout().then(isSuccess => {
  //       const loginPayload = { isLoggedIn: false };
  //       dispatch({ type: 'LOG_IN', payload: loginPayload });
  //       const deviceIdKey = 'updatedDeviceId';
  //       clearStorageExceptKey(sessionStorage, deviceIdKey);
  //       clearStorageExceptKey(localStorage, deviceIdKey);
  //       store.dispatch({ type: 'LOGOUT' });
  //       navigate('/');
  //       window.location.href = window.location.origin;
  //     })
  //   }
  // };

  // useEffect(() => {
  //   if (!ISDEV_ENV) {
  //     window.addEventListener('popstate', function (event) {
  //       handleLogout()
  //     });
  //     window.addEventListener('beforeunload', function (event) {
  //       handleLogout()
  //     });
  //   }
  // }, []);

  // Effect for fetching data userProfile

  useEffect(() => {
    if (userPreferredName !== undefined && userPreferredName != null) {
      setUserName(userPreferredName);
    }
    if (cards !== null && cards !== undefined) {
      cards.map((item) => {
        const { AccountTypeName, CardKey } = item;
        if (AccountTypeName == SPENDING || AccountTypeName == CHECKING) {
          getAmountUsedDetails(AccountTypeName, CardKey);
        }
      });
    }
    // setTimeout(() => {
    //   checkAndNavigateToPath()
    // }, 2000);
  }, []);

  useEffect(() => {
      const NotificationForBadge = `NotificationModalfor_kudzu_badge-${cards[0].CardKey}`;
      const NotificationState = sessionStorage.getItem(NotificationForBadge);
      if (NotificationState == 'false' || NotificationState == undefined) {
        setShowNotificationModal(true)
      }
      else {
        setShowNotificationModal(false)
      }
    }, [])

  async function checkAndNavigateToPath() {
    const path = await retrieveData("DEEPLINK_PATH");
    if (path != "" && path != null && path.toLowerCase() != "/home") {
      storeData("DEEPLINK_PATH", "");
      if (
        path.toLowerCase().includes("viewcard") ||
        path.toLowerCase().includes("changepin")
      ) {
        navigate("/CardServices/CardActionScreen");
      } else {
        navigate(path);
      }
    }
  }

  // Effect for fetching getAmountUsedDetails
  async function getAmountUsedDetails(AccountTypeName, cardKey) {
    if (cardKey != 0 && cardKey != undefined) {
      setIsLoading(true);
      var url = GET_USED_AMOUNT_DETAILS + cardKey + "&days=" + spendAmountDays;
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      var response = await GetRequest(url, headers);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      var responseObj = JSON.parse(response);
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        if (responseObj.Response != undefined) {
          if (responseObj.Response.amount != undefined) {
            const amount = parseFloat(responseObj.Response.amount).toFixed(2);
            if (AccountTypeName == CHECKING || AccountTypeName == SPENDING) {
              setCheckingSpentAmmount(
                amount == 0.0 ? "0.00" : amount.toString()
              );
            } else {
              setSavingsSpentAmmount(
                amount == 0.0 ? "0.00" : amount.toString()
              );
            }
          }
        }
      }
    }
  }

  const handleCardAction = (type, isSMICard) => {
    setIsSMICard(isSMICard);
    if (type == t('view_card')) {
      logFirebaseEvents("Spendings", "View_card_Clicked", "View_card_Clicked", "", "");
      if (MFAValues) {
        setTimeout(() => {
          navigate('/CardServices/CardActionScreen/ViewCard')
        }, 500);
      }else{
      setSelectedOption(t('view_card_details'))
      }
    } else {
      setSelectedOption(type)
    }

    // alert(type);
    if (type == t("lock_card")) {
      logFirebaseEvents(
        "Home",
        "Lock_Card_Clicked",
        "Lock_Card_Clicked",
        "",
        ""
      );
      showAlertModal(
        true,
        t("are_you_sure"),
        t("this_card_will_be_locked"),
        t("once_you_lock_your_card_any_new_transactions_will_be_declined"),
        true,
        true,
        t("lock_card"),
        t("cancel"),
        true,
        lockCardGreen,
        "",
        false,
        true,
        false,
        true,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
    } else if (type == t("unlock_card")) {
      dispatch({
        type: "SELECTED_USER_CARD_DETAILS",
        payload: { selectedCardDetails: cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE) },
      });
      // if (!twoFactAuthenticationDone) { setshow2faSelection(true) }
      // else { showAlertModal(true, t("ready_to_unlock_questionmark"), t("unlock_your_card_to_resume_normal_use"), t('once_you_unlock_your_card_all_locked'), true, true, t('unlock_card'), t("cancel"), true, unLockCardGreen, '', false, true, true, false, undefined, undefined, undefined, undefined, undefined, undefined, false) }
      showAlertModal(
        true,
        t("ready_to_unlock_questionmark"),
        t("unlock_your_card_to_resume_normal_use"),
        t("once_you_unlock_your_card_all_locked"),
        true,
        true,
        t("unlock_card"),
        t("cancel"),
        true,
        unLockCardGreen,
        "",
        false,
        true,
        true,
        false,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
    } else if (type == t("view_card")) {
      logFirebaseEvents("Home", "Spending_Clicked", "Spending_Clicked", "", "");
      dispatch({
        type: "SELECTED_USER_CARD_DETAILS",
        payload: { selectedCardDetails: cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE) },
      });
      if (MFAValues) {
        setTimeout(() => {
          navigate('/CardServices/CardActionScreen/ViewCard')
        }, 500);
      } else {
        if (!twoFactAuthenticationDone) { setshow2faSelection(true) }
        else {
          setTimeout(() => {
            navigate('/CardServices/CardActionScreen/ViewCard')
          }, 500);
        }
      }
    } else if (type == t("QucikBtnTransfermoney")) {
      logFirebaseEvents(
        "Home",
        "Transfer_Money_Clicked",
        "Transfer_Money_Clicked",
        "",
        ""
      );
      dispatch({
        type: "SELECTED_SUB_INDEX",
        payload: { selectedSubIndex: 1 },
      });
      const currentCard = cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)
      global.selectedAccountServiceCardKey = currentCard?.CardKey;
      navigate(currentCard?.AccountTypeBit63 === 1 ? "/AccountServices/smiONECard/TransferMoney" : "/AccountServices/Spending/TransferMoney");
    } else if (type == t("QucikBtnMoreActions")) {
      logFirebaseEvents(
        "Home",
        "More_Actions_Clicked",
        "More_Actions_Clicked",
        "",
        ""
      );
      navigate("/AccountServices");
    }
  };

  // Simple handler for API-driven secured credit popover
  const handleSecuredCreditPopoverClose = () => {
    dispatch({ type: HIDE_SECURED_CREDIT_POPOVER });
  };

  const callApiToLockCard = async () => {
    setIsLoading(true);
    setShowModel(false);
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    let object = {
      CardKey: cards !== null ? cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey : 0,
    };
    PostRequest(LOCK_CARD_API, object, headers).then((response) => {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);

      let responseObj = JSON.parse(response);
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        setTimeout(() => {
          updateCardStatus(
            cards !== null ? cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey : 0,
            responseObj.Response
          );
          showAlertModal(
            true,
            t("done_exclamation"),
            t("this_card_is_now_locked"),
            t("any_new_tx_will_be_declined"),
            true,
            false,
            "Ok",
            "",
            true,
            lockCardGreenTick,
            "",
            false,
            false,
            true,
            false,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            false
          );
        }, 1000);

        // this.updateCardsInLocal(responseObj.Response, LOCK_CARD)
      } else {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(
          true,
          t("oops_exclamation"),
          "",
          displayText,
          true,
          false,
          "Ok",
          "",
          true,
          warningImg,
          "",
          false,
          false,
          true,
          false,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        );
        setTimeout(() => {}, 1000);
      }
    });
  };

  const updateCardStatus = (cardKey, response) => {
    const updatedCardIndex = cards?.findIndex(
      (card) => card.CardKey === cardKey
    );
    if (updatedCardIndex !== -1) {
      const updatedCard = {
        ...cards[updatedCardIndex],
        Status: response.Status,
        SubStatus: response.SubStatus,
        StatusCode: response.StatusCode,
        SubStatusCode: response.SubStatusCode,
        // NewCardRequestedDate: response.NewCardRequestedDate !== undefined ? response.NewCardRequestedDate : Moment().format("YYYY-MM-DD") + "T" + "00:00:00",
      };
      const updatedArray = [
        updatedCard,
        ...cards.filter((card) => card.CardKey !== cardKey),
      ];
      dispatch({
        type: "UPDATE_USER_CARDS",
        payload: { userCards: JSON.stringify(updatedArray) },
      });
      dispatch({
        type: "SELECTED_USER_CARD_DETAILS",
        payload: { selectedCardDetails: updatedCard },
      });
    }
  };
  const callApiToUnlockCard = async () => {
    if (cards == null || cards == undefined) {
      return;
    }
    setIsLoading(true);
    setShowModel(false);

    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    let object = {
      CardKey: cards !== null ? cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey : 0,
    };

    PostRequest(UNLOCK_CARD_API, object, headers).then((response) => {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);

      let responseObj = JSON.parse(response);
      if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        setTimeout(() => {
          setShowModel(false);
          updateCardStatus(
            cards !== null ? cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey : 0,
            responseObj.Response
          );
          showAlertModal(
            true,
            t("success_heading"),
            t("this_card_is_now_unocked"),
            t("you_can_use_your_card"),
            true,
            false,
            "Ok",
            "",
            true,
            unLockCardGreen,
            "",
            false,
            false,
            true,
            false,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            false
          );
        }, 1000);

        // this.updateCardsInLocal(responseObj.Response, UNLOCK_CARD)
      } else {
        setShowModel(false);
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(
          true,
          t("oops_exclamation"),
          "",
          displayText,
          true,
          false,
          "Ok",
          "",
          true,
          warningImg,
          "",
          false,
          false,
          true,
          false,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        );
        setTimeout(() => {}, 1000);
      }
    });
  };
  const generate2FAOtp = async (type) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);

    const requestObject = {
      cardKey: SelectedCardDetails?.CardKey,
    };
    if (type !== undefined || type !== null) {
      requestObject.IsEmail = type == "Email" ? true : false;
    }

    let url;
    setIsLoading(true);

    switch (selectedOption) {
      case t("view_card"):
        url = GENERATE_OTP_VIEW_CARD;
        break;
      case t("unlock_card"):
        url = GENERATE_UNLOCK_CARD_OTP.replace(
          "{cardKey}",
          `${SelectedCardDetails.CardKey}`
        );
        break;
      default:
        url = GENERATE_OTP_VIEW_CARD;
        break;
    }
    try {
      const response = await PostRequest(url, requestObject, headers);
      setIsLoading(false);

      const parsedResponse = JSON.parse(response);
      if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
        //adding sessionid to redux
        const loginSessionPayLoad = {
          loggedSessionKey: parsedResponse.Response.sessionId,
        };
        dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
        //adding userid to redux
        const userIdPayload = { userId: parsedResponse.Response.userId };
        dispatch({ type: "USER_ID", payload: userIdPayload });
        setTimeout(() => {
          setIsOTPVerifyModalOpen(true);
        }, 1000);
      } else {
        const arrMessages = parsedResponse.Messages;
        const message = arrMessages[0];
        const displayText = message.DisplayText;
        showAlertModal(
          true,
          t("oops_exclamation"),
          "",
          displayText,
          true,
          true,
          t("home"),
          t("back_to_card_services"),
          true,
          warningImg,
          "",
          false,
          false,
          true,
          false,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        );

        // Handle the error message or displayText as needed
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const canCreateSavingsAccount = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setIsLoading(true);

    let finalUrl = CAN_CREATE_SAVINGS_ACC(cards?.find(item => isSMICard ? item.AccountTypeBit63 == 1 : item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey);
    var response = await GetRequest(finalUrl, headers);
    var responseObj = JSON.parse(response);
    setIsLoading(false);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      const canCreateNew = responseObj.Response.canCreateNew;
      const eligibleDate = moment(responseObj.Response.eligibleDate).format(
        "MM/DD/YYYY"
      );
      if (canCreateNew) {
        enrollSavingsAccount();
      } else {
        showAlertModal(
          true,
          t("oh_no"),
          t("unable_to_open"),
          `${t("u_will_be_eligible")} ${eligibleDate}. `,
          true,
          false,
          t("home"),
          "",
          true,
          require("../../assets/images/illo-report.png"),
          "",
          false,
          false,
          false,
          false,
          "",
          "",
          false,
          "",
          "",
          "",
          false,
          true
        );
      }
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(
          true,
          t("oh_no"),
          displayText,
          "",
          true,
          false,
          t("home"),
          "",
          true,
          require("../../assets/images/illo-report.png")
        );

        // setError(displayText)
      }, 500);
    }
  };

  const subComponent = () => {
    return (
      <div className=" flex justify-start items-start">
        <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">
          {t("pl_contact_customer")}
          <span
            className="text-[#2965FB] cursor-pointer"
            onClick={() =>
              window.open("https://www.kudzumoney.com/contact-us", "_blank")
            }
          >
            {t("support_email")}
          </span>
          {t("for_access")}
        </p>
      </div>
    );
  };

  const enrollSavingsAccount = () => {
    const savingsNewPayload = { savingsNewClicked: true };
    dispatch({ type: "SAVINSGS_DISABLED", payload: savingsNewPayload });
    if (kudzuPlusTrue) {
      showAlertModalPlus(
        true,
        "",
        promoKey == PAID_PROMO_KEY
          ? t("Get_1.25%_APY_on_an_optional_savings_account_with_trial")
          : t("Get_1.25%_APY_on_an_optional_savings_account"),
        "",
        true,
        true,
        t("enroll"),
        t("may_be_later"),
        true,
        require("../../assets/kudzu-plus-images/Benificiary.png"),
        "",
        true,
        "#262B3A",
        "",
        true,
        "",
        false,
        false,
        true,
        true
      );
    } else {
      showAlertModal(
        true,
        "",
        t("set_aside_money_for_the_things_that_matter"),
        t("add_savings_account_subTitle"),
        true,
        true,
        t("enroll"),
        t("may_be_later"),
        true,
        require("./../../assets/images/beneficiarysaving.png"),
        "",
        false,
        true,
        true,
        false,
        "bg-[#E4F1EB]",
        "#FEFAEE",
        true,
        "#559C7E",
        "#30BC89",
        "#30BC89",
        true
      );
    }
  };
  const closeOTPVerifyModal = () => {
    setIsOTPVerifyModalOpen(false);
  };
  const verificationSuccess = (type, verifyResponse) => {
    if (selectedOption == t("unlock_card")) {
      updateCardStatus(
        cards !== null ? SelectedCardDetails.CardKey : 0,
        verifyResponse.Response
      );
      // callApiToUnlockCard();
      showAlertModal(
        true,
        t("success_heading"),
        t("this_card_is_now_unocked"),
        t("you_can_use_your_card"),
        true,
        false,
        "Ok",
        "",
        true,
        lockCardGreenTick,
        "",
        true,
        false,
        true,
        false,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      );
    } else if (selectedOption == t("view_card_details")) {
      setTimeout(() => {
        navigate("/CardServices/CardActionScreen/ViewCard");
      }, 500);
    }
  };
  const onCancelBtnClick = () => {
    if (btn2Text == "Cancel") {
      setShowModel(false);
    } else if (btn2Text == t("may_be_later")) {
      setShowModel(false);
      showAlertModal(
        true,
        "",
        t("savings_no_problem_title"),
        t("via_account_services_title"),
        true,
        false,
        t("okay_got_it"),
        "",
        true,
        appThemeData.cell,
        "",
        false,
        true,
        true,
        false,
        "bg-[var(--text-bg-subway)]",
        "#FEFAEE",
        true,
        "#559C7E",
        "#30BC89",
        "#30BC89",
        true
      );
    } else if (btn1Text == t("back_to_card_services")) {
      closeModel();
      navigate("/CardServices");
    }
  };
  const onAcptBtnClick = () => {
    if (btn1Text == t("lock_card")) {
      callApiToLockCard();
    } else if (btn1Text == t("unlock_card")) {
      if (MFAValues) {
        callApiToUnlockCard();
      } else {
        if (!twoFactAuthenticationDone) {
          closeModel();
          setshow2faSelection(true);
        } else callApiToUnlockCard();
      }
    } else if (btn1Text == t("enroll")) {
      //need to show
      closeModel();
      navigate("/SetupSavingsAccount");
      dispatch({
        type: "SSN_SCREEN_THROUGH",
        payload: { ssnScreenThrough: t("account_services_savings_enrollment") },
      });
    } else if (btn1Text == t("okay_got_it")) {
      closeModel();
    } else if (btn1Text == "Ok") {
      closeModel();
    } else if (btn1Text == t("home")) {
      closeModel();
    }
  };
  const closeModel = () => {
    setShowModel(false);
  };

  //                      showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter
  const showAlertModal = (
    showModel,
    highlightMsg,
    headerMsg,
    subHeaderMsg,
    btn1Exists,
    btn2Exists,
    btn1Text,
    btn2Text,
    btn1TypeAcpt,
    modelImage,
    footerMsg,
    showErrorImg,
    isBorderNone,
    btn1Focus,
    btn2Focus,
    modalBg,
    btn1TextColor,
    btn1BrExist,
    btn2TextColor,
    btn1BgColor,
    btn1BorderColor,
    savingsTheme,
    isSubFooter
  ) => {
    setshowErrorImg(showErrorImg);
    setisBorderNone(isBorderNone);
    setShowModel(showModel);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
    setFooterMsg(footerMsg);
    setBtn1Focus(btn1Focus);
    setBtn2Focus(btn2Focus);
    setModalBg(modalBg);
    setBtn1TextColor(btn1TextColor);
    setBtn1BrExist(btn1BrExist);
    setBtn2TextColor(btn2TextColor);
    setBtn1BgColor(btn1BgColor);
    setBtn1BorderColor(btn1BorderColor);
    setSavingsTheme(savingsTheme);
    setIsSubFooter(isSubFooter);
  };

  ///home header
  const getHeaderText = () => {
    if (showWelcomHeader)
      return LineBreaks(
        `${t("hello_user").replace("{USER}", userName)}\n${
          appThemeData.welcomeKudzuText
        }`
      );
    return LineBreaks(
      `${t("hello_user").replace("{USER}", userName)}\n${t(
        "spent_on_card"
      ).replace("{AMOUNT}", checkingSpentAmmount ? checkingSpentAmmount : "0.00")}`
    );
  };

  useEffect(() => {
    const sessionGetForHomePopup = sessionStorage.getItem("plusModalClosedHome");
    const tooltipCookieNameForHomeGet = `freeTrial_modal_home${cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey}`;
    const modalShown = Cookies.get(tooltipCookieNameForHomeGet);
    //for expired flow carousel condition
    const expiredFlowCookiesGet = `expiredFlow${cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.ExternalSVAID}`;
    const expiredFlowModalShow = Cookies.get(expiredFlowCookiesGet);
    if (!kudzuPlusTrue) {
      if (!subScriptionCanceled && (modalShown == undefined || modalShown == "false") && sessionGetForHomePopup == null && isShowKudzuPlusPrompt === true || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true
    ) {
        showAlertModalPlus(
          true,
          promoKey == PAID_PROMO_KEY ? "" : t("thanks"),
          promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true
            ? addLineBreaks(
                t(
                  "paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus"
                )
              )
            : t("Try_a_Kudzu+_membership_for_three_months"),
          "",
          true,
          true,
          t("Learn_More"),
          t("No_Thanks"),
          true,
          require("./../../assets/kudzu-plus-images/K-plus-logo.png"),
          "",
          true,
          "#262B3A",
          promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true
            ? t("monthly_memebership_fee_will_be_automatically_deducted")
            : t("first_three_months_charged_automatically"),
          true,
          "",
          false,
          false,
          true,
          false
        );
      }
      else if(subScriptionCanceled && (expiredFlowModalShow == undefined || expiredFlowModalShow == "false")){
        setExpiredFlow('expiredFlow')
       logFirebaseEvents("Home", "Extend_kudzu_Clicked", "Extend_kudzu_Clicked", "", "");
       setShowPlusModal(false)
       const currentPath = { currentPathFromStore: currentpath.pathname };
       dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
       setShowCarouselScreensShow((prev) => !prev);
       // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
       const data = { kudzuFlowFrom: "fromExtendFlow" };
       dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
     }
    }
  }, []);

  // useEffect(() => {
  //   const isPlusModalClosed = localStorage.getItem('plusModalClosed') === 'true';
  //   if (!kudzuPlusTrue) {
  //     if (!isPlusModalClosed) {
  //       showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
  //     }
  //   }  
  // }, [])



  const showAlertModalPlus = (
    showPlusModal,
    highlightMsg,
    headerMsg,
    subHeaderMsg,
    btn1Exists,
    btn2Exists,
    btn1Text,
    btn2Text,
    btn1TypeAcpt,
    modelImage,
    carousel,
    isBorderNone,
    btn1BgColor,
    summaryParagraph,
    opacityValue,
    comparisonScreen,
    fullWidth,
    footerButtonEnable,
    gradientButton,
    largeImage
  ) => {
    setShowPlusModal(showPlusModal);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
    setBtn1Exists(btn1Exists);
    setBtn1Text(btn1Text);
    setCarousel(carousel);
    setisBorderNone(isBorderNone);
    setBtn1BgColor(btn1BgColor);
    setSummaryParagraph(summaryParagraph);
    setOpacityValueLow(opacityValue);
    setComparisonScreen(comparisonScreen);
    setFullWidth(fullWidth);
    setFooterButtonEnable(footerButtonEnable);
    setGradientButton(gradientButton); // gradient button for popup
    setLargeImage(largeImage);
  };

  const onCancelBtnClickPlusModal = () => {
    logFirebaseEvents(
      "Home",
      "Kudzu_Plus_No_Thanks_Clicked",
      "Kudzu_Plus_No_Thanks_Clicked",
      "",
      ""
    );
    // localStorage.setItem('plusModalClosed', 'true');
    const tooltipCookieNameForHome = `freeTrial_modal_home${cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey}`;
    Cookies.set(tooltipCookieNameForHome, "true", { expires: 1825 });
    setShowPlusModal(false);
    if (btn2Text == t("may_be_later") && kudzuPlusTrue) {
      setShowPlusModal(false);
      showAlertModal(
        true,
        "",
        <p>
          <span className="text-[var(--enroll-maybelater-hilight)]">
            {t("no_problem_exclimation")}
          </span>
          <span> </span>
          {t("You_may_add_a_Kudzu_SavingsAc_count_at_any_time")}
        </p>,
        t("via_account_services_title"),
        true,
        false,
        t("okay_got_it"),
        "",
        true,
        appThemeData.cell,
        "",
        false,
        true,
        true,
        false,
        "bg-[var(--text-bg-subway)]",
        "#FEFAEE",
        kudzuPlusTrue ? false : true,
        "#559C7E",
        kudzuPlusTrue ? "" : "#30BC89",
        "#30BC89",
        true
      );
    }
  };

  const onAcptBtnClickPlusModal = () => {
    logFirebaseEvents(
      "Home",
      "Kudzu_Plus_Learn_More_Clicked",
      "Kudzu_Plus_Learn_More_Clicked",
      "",
      ""
    );
    setShowPlusModal(false);
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: "CURRENT_LOCATION", payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
    const data = { kudzuFlowFrom: "login" };
    dispatch({ type: "KUDZU_PLUS_FROM", payload: data });
    if (btn1Text == t("enroll") && kudzuPlusTrue) {
      //need to show
      closeModel();
      navigate("/SetupSavingsAccount");
      dispatch({
        type: "SSN_SCREEN_THROUGH",
        payload: { ssnScreenThrough: t("account_services_savings_enrollment") },
      });
    }
  };

  const closeModelPlus = () => {
    sessionStorage.setItem("plusModalClosedHome", "true");
    setShowPlusModal(false);
    setShowCarouselScreensShow(false);
  }

  const extendFlowCloseCallbackFunction = (val) =>{
    setShowCarouselScreensShow(val)
  }

  const isNotificationClose = () => {
    setIsNotificationOpen(false);
    dispatch({
      type: "ANY_IN_APP_NOTIFICATIONS",
      payload: { anyInAppNotifications: false }
    });
  }

  const [showbanner, setShowBanner] = useState(false)
 
     const handleExploreClick = () => {
       const bannerNameForSaving = `banner_for_kudzu-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey}`;
       Cookies.set(bannerNameForSaving, 'true', { expires: 1825 }, 2);
       setShowBanner(false)
       navigate("/Settings/ManageMembershipKudzuPlus")
     }
 
     const handlebannerCloseClick = () => {
      const bannerNameForSaving = `banner_for_kudzu-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey}`;
      Cookies.set(bannerNameForSaving, 'true', { expires: 1825 }, 2);
      setShowBanner(false)
    }
 
    useEffect(() => {
      const kadzuBanner = `banner_for_kudzu-${promoKey == PAID_PROMO_KEY ? "Trial" : "Plus" + cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.CardKey}`;
      const banner = Cookies.get(kadzuBanner);
      if (banner == 'false' || banner == undefined) {
        setShowBanner(true)
      }
      else {
        setShowBanner(false)
      }
    }, [])

  return (
    <HomeLayout
      showBanner={showbanner}
      handleExploreClick={handleExploreClick}
      handleBannerCloseClick={handlebannerCloseClick}
    >
      <HomeHeader heading={getHeaderText()} isHeaderCaption={true} />
      {showCarouselScreenShow &&
        <MemnershipEnrollmentScreens extendFlowCloseCallbackFunction = {extendFlowCloseCallbackFunction} expiredFlow = {expiredFlow} />}
      <div
        className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
      animate__animated animate__fadeInRight"
      >
        {cards !== null &&
  cards?.find(
    (item) =>
      item.ProgramKey !== 200
  ) && (
    <SmioneCard hideLayout Radius={isEvenLength} handleCardAction={handleCardAction} />
  )}

{cards !== null &&
  cards?.find(
    (item) =>
      item.AccountTypeBit63 == CHECKING_CARD_CODE && item.Balance != 0
  ) && (
    <Checking
      hideLayout
      Radius={isEvenLength}
      handleCardAction={handleCardAction}
    />
  )}

{savingsCardExist && savingsWithBalanceOver0 && (
  <Savings hideLayout Radius={isEvenLength} />
)}


        {/*  kudzu  savings enroll card */}

        {savingsCardAvailable == false && !kudzuPlusTrue && cards !== null && cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.AllowSavings && (
          <FooterContent
            cardHeight={"200px"}
            backgroundColor={"#D3D3D3"}
            btnBgColor={"#00654f"}
            btnTextColor={"#FFFFFF"}
            isSubheadingwidth={true}
            highlightTextColor={"#0C4437"}
            subHeaderTextColor={"#0C4437"}
            highlightText={t("Enroll_Header")}
            subHeaderText={LineBreaks(t("Enroll_Savings_Footer"))}
            image={beneficiarysaving}
            buttonEnabled={true}
            buttonText={t("Learn More")}
            isSpace={true}
            footerBtnAction={canCreateSavingsAccount}
            type={"AddSavings"}
            borderDirection={
              cards?.[0]?.AllowPayPerks
                ? cards?.length % 2 == 0
                  ? "odd"
                  : "even"
                : cards?.length % 2 == 0
                ? "even"
                : "odd"
            }
          />
        )}

        {/* // kudzu plus savings enroll card */}
        {savingsCardAvailable == false && kudzuPlusTrue && hasKudzuCard &&(
          <DynamicCard
            footer={true}
            header={false}
            CardRadius={false}
            cardWidth={width.homeCard}
            HeaderRadius={false}
            isWhite={appThemeData.isWhiteBgForCard}
            isDarkForKudzu={appThemeData.isDarkBgForCard}
            backgroundColor={"--cardHeading-bg"}
            HeaderContent={
              <>
                <CardHeading
                  heading={t("savings")}
                  image={appThemeData.isBlueIconForSavings}
                  endBtnText={t("enroll")}
                  endBtn={true}
                  headerButtonClick={canCreateSavingsAccount}
                />
              </>
            }
          >
            <div className="my-20">
              <div className="flex justify-between">
                <div>
                  <p className="text-white md:w-[310px]">
                    {t("set_aside_money_for_things_that_matter")}
                  </p>
                </div>
                <div>
                  <img src={Benificiary} alt="Benificiary" />
                </div>
              </div>
            </div>
          </DynamicCard>
        )}
        {/* these are new requirement changes */}

        {cards !== null &&
          cards?.find(
            (item) =>
              item.AccountTypeBit63 == CHECKING_CARD_CODE && item.Balance == 0
          ) && (
            <AddMoneyComponent
              selectedItem={cards.find(
                (item) => item.AccountTypeBit63 == CHECKING_CARD_CODE
              )}
         
              titleTextColor="text-white"
              backgroundColor={kudzuPlusTrue? "--navbar-bg" :"--spending-card-border-clr"}
              btnBgColor={"#30BC89"}
              highlightTextColor={kudzuPlusTrue? "text-white" :"text-[#00654F]"}
              highlightText={t("spending_empty_account")}
              buttonText={t("addMoneyTittle")}
              btnTextColor={"#FFFFFF"}
              footerBtnAction={() => {
                let cardObject = cards.find(
                  (item) => item.AccountTypeBit63 == CHECKING_CARD_CODE
                );
                global.selectedAccountServiceCardKey = cardObject.CardKey;
                logFirebaseEvents(
                  "Home",
                  "Spending_add_Money_Clicked",
                  "Spending_add_Money_Clicked",
                  "",
                  ""
                );
                navigate("/AccountServices/Spending/TransferMoney");
              }}
              borderDirection={true}
            />
          )}
        {savingsCardExist && !savingsWithBalanceOver0 && (
          <AddMoneyComponent
            selectedItem={cards.find(
              (item) => item.AccountTypeBit63 == SAVING_CARD_CODE
            )}
             headerBgColor="#A3CEBB"
            backgroundColor={kudzuPlusTrue? "--navbar-bg" :"--spending-card-border-clr"}
            titleTextColor="text-white"
            cardHeight="200px"    
            btnBgColor="#30BC89"
            highlightTextColor={kudzuPlusTrue? "text-white" :"text-[#00654F]"}
            highlightText={t("saving_empty_account")}
            buttonText={t("addMoneyTittle")}
            btnTextColor="#FFFFFF"
            footerBtnAction={() => {
              let cardObject = cards.find(
                (item) => item.AccountTypeBit63 == SAVING_CARD_CODE
              );
              global.selectedAccountServiceCardKey = cardObject.CardKey;
              logFirebaseEvents(
                "Home",
                "Savings_add_Money_Clicked",
                "Savings_add_Money_Clicked",
                "",
                ""
              );
              navigate("/AccountServices/Savings/TransferMoney");
            }}
            borderDirection={false}
          />
        )}

      {/* Set Up 2-Day Early ACH Access */}
        {/* {
          showSetupAccessCard ? (
            <FooterContent
            highlightText={t("set_up_to")}
            subHeaderText={addLineBreaks(t("Get_Access_for_deposit"))}
            image={ach_acces_image}
            imageCancelIcon ={crossIcon}
            buttonEnabled={true}
            buttonText={t("learn_more")}
            type={t("LernMoreKudzuPlusSavingGoal")}
            borderDirection={"odd"}
            isSubheadingwidth={false}
            footerBtnAction = {hnaldeSetupAccessCloseBtn}
          />
          ) :''
        } */}
    {allowSecuredCredit && (!isSecuredCreditAccountAvailable && ( <SecuredCreditCardPromotion Radius={isEvenLength} />))}
        
    {isSmiOneIsTrue ? ( 
      <>
      {hasKudzuCard &&
<SmiPayPerks />
      }</>

) : (
  cards !== null &&
  cards?.find(item => item.AccountTypeBit63 == CHECKING_CARD_CODE)?.AllowPayPerks && (
kudzuPlusTrue? <NewPayPerks /> : <PayPerks Radius={isEvenLength} isCardRadius={isSecuredCreditAccountAvailable} />
  )
)}
       

        {/* //new learn more card for kudzu plus membership */}

        {!kudzuPlusTrue && isShowKudzuPlusPrompt && (
          <FooterContent
            highlightText={
              promoKey == PAID_PROMO_KEY
                ? addLineBreaks(
                    t(
                      "get_access_to_more_features_and_benefits_with_kudzu_plus"
                    )
                  )
                : addLineBreaks(
                    t("Get_More_Kudzu_with_a_Free_3-Month_Trial-of_Kudzu+")
                  )
            }
            subHeaderText={
              promoKey == PAID_PROMO_KEY
                ? t("about_the_benefits_of_Kudzu+")
                : t("Learn_more_about_the_benefits_of_Kudzu+")
            }
            image={kudzuPlusLogo}
            buttonEnabled={true}
            btnBgColor={"transparent"}
            buttonText={t("learn_more")}
            isSpace={true}
            gradientBackground={true}
            btnTextColor={"white"}
            footerBtnAction={() => {
              dispatch({
                type: "CLIMB_POPUP_SHOWVALUE",
                payload: { climbPopShowValue: false },
              });
              const currentPath = {
                currentPathFromStore: currentpath.pathname,
              };
              dispatch({ type: "CURRENT_LOCATION", payload: currentPath });
              setShowCarouselScreensShow(false);
              // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
              showAlertModalPlus(
                true,
                promoKey == PAID_PROMO_KEY ? "" : t("thanks"),
                promoKey == PAID_PROMO_KEY
                  ? addLineBreaks(
                      t(
                        "paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus"
                      )
                    )
                  : t("Try_a_Kudzu+_membership_for_three_months"),
                "",
                true,
                true,
                t("Learn_More"),
                t("No_Thanks"),
                true,
                require("./../../assets/kudzu-plus-images/K-plus-logo.png"),
                "",
                true,
                "#262B3A",
                promoKey == PAID_PROMO_KEY
                  ? t("monthly_memebership_fee_will_be_automatically_deducted")
                  : t("first_three_months_charged_automatically"),
                true,
                "",
                false,
                false,
                true,
                true
              );

              const data = { kudzuFlowFrom: "login" };
              dispatch({ type: "KUDZU_PLUS_FROM", payload: data });
              logFirebaseEvents(
                "Home",
                "Kudzu_Plus_Learn_More_Card_Clicked",
                "Kudzu_Plus_Learn_More_Card_Clicked",
                "",
                ""
              );
            }}
            type={"climbFooter"}
            borderDirection={"even"}
            // borderDirection={
            //   cards?.[0]?.AllowPayPerks
            //     ? cards?.length % 2 == 0
            //       ? "odd"
            //       : "even"
            //     : cards?.length % 2 == 0
            //     ? "even"
            //     : "odd"
            // }
            subHeadingVisiblity={true}
          />
        )}
       

              {cards !== null && cards?.find(item => item.ProgramKey == 200 && item.AccountTypeBit63 == CHECKING_CARD_CODE)?.IsClimbAllowed &&
         <FooterContent
          highlightText={t('Financial_growth_starts')}
          subHeaderText={t("Your_toolkit_helps_you")}
          image={appThemeData.ClimbImg}
          buttonEnabled={true}
          buttonText={t("climb_btn")}
          isSpace={true}
          footerBtnAction={() => {
            const currentPath = { currentPathFromStore: currentpath.pathname };
            dispatch({ type: "CURRENT_LOCATION", payload: currentPath });
            navigate("/Toolkit/ToolkitMenu", {
              state: { isClimbShowPopups: true },
            });
            // navigate("/Climb");
            logFirebaseEvents(
              "Home",
              "Explore_Climb_Clicked",
              "Explore_Climb_Clicked",
              "",
              ""
            );
          }}
          type={"climbFooterHome"}
          borderDirection={ isShowKudzuPlusPrompt ? "odd" :
            cards?.[0]?.AllowPayPerks 
              ? (cards?.length ) % 2 == 0 && isSecuredCreditAccountAvailable 
                ? "even"
                : "odd"
              : (cards?.length) % 2 == 0
              ? "odd"
              : "even"
          }
          subHeadingVisiblity={true}
        />}


        {(userMembershipData?.extendTrial) && <FooterContent highlightText={
          <p className='text-white'>Your Kudzu+ Membership Expires in
            <span className="bottomBorder">{" " + userMembershipData?.extendTrial ? userMembershipData?.daysRemaining : ""}</span> Days</p>
        }
          // isSpace={true}
          subHeaderText=""
          isStartImage={true}
          image={KudzuPlusLogo} buttonEnabled={true} gradientBorder={true}
          buttonText="Extend Kudzu"
          footerBtnAction={() => {
            logFirebaseEvents("Home", "Extend_kudzu_Clicked", "Extend_kudzu_Clicked", "", "");
            setShowPlusModal(false)
            const currentPath = { currentPathFromStore: currentpath.pathname };
            dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
            setShowCarouselScreensShow((prev) => !prev);
            // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
            const data = { kudzuFlowFrom: "fromExtendFlow" };
            dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
          }}
          borderDirection={true}
          isSubheadingwidth={false}
          largeImage={true}
          type ={'extendFlow'}
        />}

        {/* {kudzuPlusTrue && <FooterContent
          highlightText={t("ACH_Text")}
          subHeaderText={t("Learn_more_about_the_benefits")}
          image={DepositIcon}
          backgroundColor={'#272626'}
          buttonEnabled={true}
          buttonText={t("learn_more")}
          isSpace={true}
          type={"LernMoreKudzuPlus"}
          subHeadingVisiblity={true}
        />} */}

        {isLoading && <Loader />}
      </div>
      <TwoFactTypeSelctionModal
        isOpen={show2faSelection}
        onClose={() => {
          setshow2faSelection(false);
        }}
        onClickNext={(object) => {
          setOtpGenerationType(object.proc);
          setshow2faSelection(false);
          generate2FAOtp(object.proc);
        }}
      />
     {!showPlusModal && !showCarouselScreenShow &&
      <>{!isLoading && notifications.length>0 && showNotificationModal && (
        <NotificationModal
        notify={notifications}
        isOpen={isNotificationOpen}
        onClose={isNotificationClose}
        subHeaderMsg={<p className="font-hanken-grotesk transition duration-1000 ease-in-out modal-title lg:text-[18px] md:text-[17px] sm:text-[15px] text-[14px] font-normal cursor-pointer pointer-events-none">NOTIFICATION</p>}
        />
      )}
      </>
     }
      <>
        {showModel && (
          <CustomAlertModel
            isOpen={showModel}
            onClose={closeModel}
            image={modelImage}
            highlightMsg={
              <p className={`${HighlightMsgStyles}`}>{highlightMsg}</p>
            }
            HeaderMsg={
              <p
                className={`${HeaderMsgStyles} ${
                  savingsTheme ? "text-[var(--text-clr-secondary6)]" : ""
                }`}
              >
                {headerMsg}
              </p>
            }
            subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
            btn1Exists={btn1Exists}
            btn2Exists={btn2Exists}
            btn1Text={btn1Text}
            btn2Text={btn2Text}
            btn1TypeAcpt={btn1TypeAcpt}
            footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
            onAcptBtnClick={onAcptBtnClick}
            onCancelBtnClick={onCancelBtnClick}
            showErrorImg={showErrorImg}
            isBorderNone={isBorderNone}
            btn1Focus={btn1Focus}
            btn2Focus={btn2Focus}
            modalBg={modalBg}
            btn1TextColor={btn1TextColor}
            btn1BrExist={btn1BrExist}
            btn2TextColor={btn2TextColor}
            btn1BgColor={btn1BgColor}
            btn1BorderColor={btn1BorderColor}
            subFooter={isSubFooter && subComponent()}
          />
        )}
      </>


      <>
       <Modal
        Fullheight={true}
        isOpen={loggedResponse?.ShowAddMoneyBanner && !closedAddMoneyModalState}
        onClose={closeAddMoneyPopOver}
        alignItems={"items-center"} 
        isKudzuPlusBg={true}
        // title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('removeSpednAlert')}</p>}
        subtitle={


          <p>
            <span className={`${HeadingStyles}`}>
              {t("Keep Your Kudzu+ Membership Active")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <AddMoneyPopover
              content1={userMembershipData?.membershipType === 'Trial' ? (t("Plus_Add_Money_Popover")) : (t("Add_Money_Popover")) }
              btn1={t("Add Money")}
              btn1Function={redirectToAddMoney}
              btn2={t("Add Later")}
              btn2Function={closeAddMoneyPopOver}
              icon={true}
            />
          </div>
        }
      />
      </>

      <>
        {isOTPVerifyModalOpen && (
          <Modal
            isOpen={isOTPVerifyModalOpen}
            onClose={closeOTPVerifyModal}
            isLogo={false}
            title={
              <p className={HighlightMsgStyles}> {t("great_exclamation")}</p>
            }
            subtitle={
              <p className={HeaderMsgStyles}>
                {otpGenerationType == "Email"
                  ? t("we_are_sending_text").replace("a text", "an email")
                  : t("we_are_sending_text")}
              </p>
            }
            subHeaderMsg={
              <p className="font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-normal cursor-pointer pointer-events-none">
                {otpGenerationType != "Email" &&
                  t("standard_msg_and_data_rates_may_apply")}
              </p>
            }
            content={
              <div className="mt-10">
                <Custom2FA
                  type={selectedOption}
                  selected2FAType={otpGenerationType}
                  onClose={closeOTPVerifyModal}
                  verificationSuccess={verificationSuccess}
                  verificationFailure={() => {}}
                />
              </div>
            }
          />
        )}
      </>
      <>
        <CustomModalPlus
          isOpen={showPlusModal}
          onClose={closeModelPlus}
          image={modelImage}
          carousel={carousel}
          summaryParagraph={
            <p className={summaryParagraphStyles}>{summaryParagraph}</p>
          }
          isBorderNone={isBorderNone}
          highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
          subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
          btn1Exists={btn1Exists}
          btn2Exists={btn2Exists}
          btn1Text={btn1Text}
          btn1BgColor={btn1BgColor}
          btn2Text={btn2Text}
          opacityLow={opacityValueLow}
          defaultCornerRadius={false}
          btn1TypeAcpt={btn1TypeAcpt}
          onAcptBtnClick={onAcptBtnClickPlusModal}
          onCancelBtnClick={onCancelBtnClickPlusModal}
          gradientButton={gradientButton}
          largeImage={largeImage}
          btn2TextColor={"#779CE5"}
        />
      </>
      {isLoading && <Loader />}
      
      {/* API-driven Secured Credit Popover for first-time users */}
      {allowSecuredCredit && (
      showSecuredCreditPopover && (
    <SecuredCreditPromoPopover
      isOpen={showSecuredCreditPopover}
      onClose={handleSecuredCreditPopoverClose}
      triggerSource="api_driven"
    />
  ))}
      
      {/* <div>
        {kudzuPlusTrue && <>
          {showbanner &&
         <MembershipBanner handleExploreClick={handleExploreClick}  handleCloseClick={handlebannerCloseClick}/>
        }
        </>}
       
      </div> */}
    </HomeLayout>
  );
};

export default withOidcSecure(Home);
